module.exports = __webpack_public_path__ + "static/RockoUltraFLF-aae9ba25125f21de39623e88a39d57e7.svg";